import styles from "./DiskusiDenganPakar.module.css"
import { Col, Row } from "antd"
import FromKonsultasi from "./FormKonsultasi"

import whatsapp from "./assets/whatsapp.svg"
import call from "./assets/call.svg"
import email from "./assets/email.svg"
import location from "./assets/location.svg"

import IG from "./assets/IG.svg"
import Linkedin from "./assets/Linkedin.svg"
import Facebook from "./assets/Facebook.svg"
import Tiktok from "./assets/Tiktok.svg"
import X from "./assets/x.svg"

import Mindo from "./assets/mindo-bg.png"

const DiskusiDenganPakar = () => {
  const socialIcons = [
    { 
      icon: IG, 
      url: "https://www.instagram.com/mindoeducation/" 
    },
    {
      icon: Linkedin,
      url: "https://www.linkedin.com/company/mindoeducation/",
    },
    { 
      icon: Facebook, 
      url: "https://www.facebook.com/mindoeducation/" 
    },
    { 
      icon: Tiktok, 
      url: " https://www.tiktok.com/@mindoeducation" 
    },
    { 
      icon: X, 
      url: "https://x.com/mindoeducation" 
    },
  ]


  return (
    <div className={styles.bodyWrap}>
      <div className={styles.body}>
        <img src={Mindo} alt="" className={styles.bgIcon} />
        <div className={`container ${styles.content}`}>
          <Row gutter={[48, 0]} className={styles.rowEqual}>
            <Col span={12} className={styles.left} data-aos="fade-up">
              <h1 className={styles.tittle}>Mulai Diskusi dengan Pakar Kami</h1>
              <p className={styles.desc}>
                Isi form di samping untuk menjadwalkan konsultasi gratis atau
                mendapatkan penawaran yang dirancang khusus untuk kebutuhan
                Anda.
              </p>

              <div className={styles.contact}>
                <h4 className={styles.titleContact}>Kontak Kami</h4>
                <div className={styles.contactList}>
                  <img src={whatsapp} alt="" />
                  <p>
                    <a
                      href="https://api.whatsapp.com/send/?phone=6282217777616&text=%23askmika%20Halo%2C%20Mika!%20Saya%20ingin%20bertanya%20mengenai.."
                      target="_blank"
                      rel="noreferrer">
                      0822-1777-7616
                    </a>
                  </p>
                </div>
                <div className={styles.contactList}>
                  <img src={call} alt="" />
                  <p>(021) 5010 1118</p>
                </div>
                <div className={styles.contactList}>
                  <img src={email} alt="" />
                  <p>cs@mindoeducation.co.id</p>
                </div>
                <div className={styles.contactList}>
                  <img src={location} alt="" />
                  <p>
                    <a
                      href="https://goo.gl/maps/M2oKYMRCYaqfyY7x8"
                      target="_blank"
                      rel="noreferrer">
                      SOHO Pancoran, <br />
                      Tower Splendor 1505, <br />
                      Tebet, Jakarta Selatan, 12810
                    </a>
                  </p>
                </div>
              </div>

              <div className={styles.contactBottom}>
                <h4 className={styles.titleContact}>
                  Lebih dekat dengan Mindo Education
                </h4>
                <div className={styles.listIcon}>
                  <Row gutter={[10, 0]}>
                    {socialIcons.map((item, index) => (
                      <a
                        href={item.url}
                        target="_blank"
                        rel="noopener noreferrer">
                        <Col key={index}>
                          <img
                            src={item.icon}
                            alt={`social-icon-${index}`}
                            className={styles.iconSocial}
                          />
                        </Col>
                      </a>
                    ))}
                  </Row>
                </div>
              </div>
            </Col>

            <Col span={12} className={styles.right} data-aos="fade-up">
              <FromKonsultasi />
            </Col>
          </Row>
        </div>
      </div>
    </div>
  )
}

export default DiskusiDenganPakar
